import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Button, Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import _e from 'common/localeUtil';
import ColorPicker from '../../color-picker/ColorPicker';
import GMButton from '../../button/GMButton';

class FieldColorPickerControl extends React.PureComponent {
	constructor(props) {
		super(props);
		const { input } = props;
		this.state = {
			anchorEl: null,
			color: input?.value || props.defaultColor,
		};
		// console.log('FieldColorPickerControl constructor', input, props.defaultColor);
	}

	componentDidUpdate(prevProps) {
		const { input, defaultColor } = this.props;
		const { input: prevInput, defaultColor: prevDefaultColor } = prevProps;

		const oldColor = prevInput?.value || prevDefaultColor;
		const color = input?.value || defaultColor;
		if (oldColor !== color) {
			this.setState({
				color,
			});
		}
		// const { defaultColor: oldDefaultColor } = prevProps;
		// const { defaultColor } = this.props;
		// if (oldDefaultColor !== defaultColor) {
		// 	console.log('FieldColorPickerControl componentDidUpdate', this.props.defaultColor);
		// 	this.setState({
		// 		color: defaultColor
		// 	});
		// }
	}

	onClose = () => {
		this.setState({
			anchorEl: null,
		});
	};

	onChange = ({ hex }) => {
		this.setState(() => ({
			color: hex,
		}));
		console.log('Color set', hex);
	};

	onHandleChange = ({ hex }) => {
		const {
			input: { onChange },
			callback,
		} = this.props;
		console.log('onHandleChange Color set', hex);
		this.setState({
			color: hex,
		});
		onChange && onChange(hex);
		callback && callback(hex);
	};

	showColorPicker = (event) => {
		this.setState({
			anchorEl: event.currentTarget,
		});
	};

	hideColorPicker = () => {
		this.setState({
			anchorEl: null,
		});
	};

	render() {
		const { classes } = this.props;
		const { color, anchorEl } = this.state;
		// console.log('FieldColorPickerControl rerender', this.props.from, color);
		return (
			<Box>
				<Button
					variant="contained"
					classes={{ root: classes.colorPickerButtonStyle }}
					onClick={this.showColorPicker}
					disableElevation
					style={{ backgroundColor: color }}
				>
					{' '}
				</Button>
				<Popover
					open={Boolean(anchorEl)}
					anchorEl={anchorEl}
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'center',
						horizontal: 'right',
					}}
					onClose={this.hideColorPicker}
				>
					<div>
						<ColorPicker
							color={color}
							defaultHex={color}
							onChange={this.onChange}
							onChangeComplete={this.onHandleChange}
						/>
						<div className={classes.actionPanel}>
							<GMButton
								variant="contained"
								color="primary"
								onClick={this.onClose}
								title={_e('confirm')}
							/>
						</div>
					</div>
				</Popover>
			</Box>
		);
	}
}

FieldColorPickerControl.propTypes = {
	input: PropTypes.object,
	classes: PropTypes.object,
	callback: PropTypes.func,
	defaultColor: PropTypes.string,
	// from: PropTypes.string
};

const styles = (theme) => ({
	actionPanel: {
		padding: theme.spacing(1),
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
	},
	colorPickerButtonStyle: {
		minHeight: 34,
		minWidth: 100,
		border: `1px solid ${theme.palette.divider}`,
	},
});
export default withStyles(styles)(FieldColorPickerControl);
